<template>
  <v-dialog width="700px" persistent v-model="dialogPreRegister">
    <v-card style="padding: 35px; border-radius: 15px">
      <v-form
        @submit.prevent="handleSubmit"
        class="pessoas-redefinir-senha-form"
      >
        <v-row class="d-flex justify-between">
          <label
            style="
              font-size: 20px;
              margin-bottom: 10px;
              font-weight: bold;
              color: #2d1a4c;
            "
            >{{ $t("sales.affiliate_settings") }}</label
          >
        </v-row>
        <v-row>
          <v-alert
            border="left"
            color="blue"
            dense
            prominent
            type="info"
            icon="mdi-alert-circle-outline"
            style="position: sticky; z-index: 9999; justify-self: flex-end"
          >
            {{ $t("sales.new_affiliate_info") }}
          </v-alert>
        </v-row>
        <v-row class="mt-10 mb-1">
          <BaseTextField
            required
            :label="$t('sales.affiliate_name')"
            v-model="fields.name"
            type="text"
            class="textinput"
            name="nome"
            tabindex="1"
            :error-messages="formErrors.nome"
            @input="formErrors.nome = ''"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-1">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              required
              :label="$t('sales.affiliate_email')"
              v-model.trim="fields.email"
              type="text"
              class="textinput"
              name="email"
              tabindex="1"
              :rules="[
                v =>
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
                  $t('sales.affiliate_email_validation'),
              ]"
              :error-messages="formErrors.email"
              @input="formatEmail"
              @keydown.space.prevent
              v-on:keydown="onKeydownEmail"
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              :label="$t('sales.affiliate_url')"
              v-model="fields.slug"
              type="text"
              class="textinput"
              name="slug"
              tabindex="1"
              @input="formatSlug"
            ></BaseTextField>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              :label="$t('sales.affiliate_cpf')"
              v-model="fields.cpf"
              type="text"
              class="textinput"
              name="cpf"
              tabindex="1"
              v-mask="'###.###.###-##'"
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              :label="$t('sales.affiliate_phone')"
              v-model="fields.phone"
              type="text"
              class="textinput"
              name="phone"
              tabindex="1"
              v-mask="'(##) #####-####'"
            ></BaseTextField>
          </v-col>
        </v-row>

        <v-row class="mb-3">
          <v-col cols="6" class="px-0">
            <v-btn rounded outlined @click="exportTrigger()" width="99%">
              {{ $t("sales.affiliate_export") }}
              <v-icon small class="d-flex justify-center align-center ml-2">
                {{ $config.icons.download }}
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pl-2 pr-0">
            <v-btn
              rounded
              outlined
              @click="handleFileImport"
              :loading="isSelecting"
              width="100%"
              :key="importButtonKey"
            >
              {{ $t("sales.affiliate_import") }}
              <v-icon small class="d-flex justify-center align-center ml-2">
                {{ $config.icons.upload }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <input
          ref="uploader"
          class="d-none"
          type="file"
          @change="onFileChanged"
        />
        <v-row>
          <v-btn
            height="45"
            class="button button-bg rounded-lg"
            block
            tabindex="4"
            type="submit"
          >
            <span>{{ $t("sales.affiliate_new_button") }}</span>
          </v-btn>
          <v-btn
            height="45"
            class="mt-3 button-bg rounded-lg"
            block
            tabindex="5"
            color="#e0e0e0"
            @click="setDialogPreRegister(false)"
          >
            <span>{{ $t("sales.affiliate_new_cancel") }}</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import { normalizeString } from "../../utils";
import { exportFunction } from "@/mixins/exportFunction";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "RegisterAffiliate",
  mixins: [exportFunction],
  components: {
    BaseTextField,
  },
  data() {
    return {
      normalizeString,
      isSelecting: false,
      selectedFile: null,
      importButtonKey: 0,
      fields: {
        name: "",
        email: "",
        slug: "",
        cpf: "",
        phone: "",
      },
      formErrors: {
        nome: "",
        email: "",
      },
    };
  },
  computed: {
    ...mapGetters(["dialogPreRegister"]),
    sendTypeStructureModel() {
      const fileName = "Afiliados-Modelo-Importacao";
      const tableHeader = ["Nome", "Email", "URL", "CPF", "Telefone"];

      const tableBody = [
        "Fulano",
        "examplo@email.com",
        "Slug",
        "123.456.789-30",
        "(11)99999-9999",
      ];

      return {
        tableHeader,
        tableBody,
        fileName,
      };
    },
  },
  _methods: {
    ...mapActions([
      "createAffiliate",
      "showSnackbarSuccess",
      "importAffiliates",
    ]),
    ...mapMutations(["setDialogPreRegister"]),
    handleFileImport() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
      this.importButtonKey++;
    },
    exportTrigger() {
      const { tableHeader, tableBody, fileName } = this.sendTypeStructureModel;
      this.export(tableHeader, tableBody, fileName);
    },
    onKeydownEmail(event) {
      if (event.keyCode === 32) {
        event.preventDefault();
      }
    },
    formatSlug() {
      this.fields.slug = this.fields.slug
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },
    formatEmail() {
      this.formErrors.email = "";
      this.fields.email = this.fields.email.replace(/\s/g, "").toLowerCase();
    },
    handleSubmit() {
      if (this.fields.name.length < 1) {
        this.formErrors.nome = this.$t("sales.affiliate_required");
        return;
      }
      if (this.fields.email.length < 1) {
        this.formErrors.email = this.$t("sales.affiliate_required");
        return;
      }
      if (
        this.fields.email.length > 0 &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.fields.email)
      ) {
        this.formErrors.email = this.$t("sales.affiliate_email_validation");
        return;
      }
      this.createAffiliate({
        nome: this.fields.name,
        email: this.fields.email,
        telefone: this.fields.phone,
        cpf: this.fields.cpf,
        slug: this.fields.slug,
        status: "ATIVO",
      }).then(() => {
        this.setDialogPreRegister(false);
      });
    },
    clearFileInput() {
      this.importButtonKey++;
    },
    callImport(data) {
      this.importAffiliates(data);
      this.clearFileInput();
    },
    onFileChanged(file) {
      var reader = new FileReader();
      this.selectedFile = file.target.files[0];

      reader.readAsText(this.selectedFile);

      reader.onload = event => {
        var csvdata = event.target.result;

        var rowsData = csvdata.split("\n");

        // eslint-disable-next-line no-unused-vars
        var removedHeaderAndEmpty = rowsData.filter(
          (item, index) => index !== 0 && item !== ""
        );

        const data = removedHeaderAndEmpty.map(item => {
          const [nome, email, slug, cpf, telefone] = item.split(",");
          return {
            nome: normalizeString(nome),
            email: normalizeString(email),
            slug: normalizeString(slug),
            cpf: normalizeString(cpf),
            telefone: normalizeString(telefone),
            status: "ATIVO",
          };
        });

        this.callImport({ afiliados: data });
      };
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
  watch: {
    "$store.getters.dialogPreRegister"() {
      this.fields.name = "";
      this.fields.email = "";
      this.fields.slug = "";
      this.fields.cpf = "";
      this.fields.phone = "";
      this.formErrors.nome = "";
      this.formErrors.email = "";
    },
  },
};
</script>

<style scoped></style>
